export interface MapCoordinates {
    lat: number;
    lng: number;
}

const coordinateNumber = (value: unknown, minimum: number, maximum: number) => {
    if (value === null || value === undefined || value === '')
        return null;

    const number = Number(value);
    return Number.isFinite(number) && number >= minimum && number <= maximum
        ? number
        : null;
};

export const getMapCoordinates = (value: any): MapCoordinates | null => {
    const candidates = [
        value,
        value?.coordinates,
        value?.geo,
        value?.location,
        value?.position,
        value?.geometry?.location,
        value?.areaOfOperations,
        value?.areaOfOperations?.coordinates,
        value?.areaOfOperations?.center,
    ];

    for (let index = 0; index < candidates.length; index++) {
        const candidate = candidates[index];
        if (!candidate)
            continue;

        const lat = coordinateNumber(
            candidate.lat ?? candidate.latitude ?? candidate.centerLat,
            -90,
            90
        );
        const lng = coordinateNumber(
            candidate.lng ?? candidate.lon ?? candidate.long ?? candidate.longitude ?? candidate.centerLng,
            -180,
            180
        );

        if (lat !== null && lng !== null && (lat !== 0 || lng !== 0))
            return { lat, lng };
    }

    return null;
};
